<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="page-title">
      <i class="pi pi-link"> </i>
      <label class="name">連携事例検索</label>
    </div>

    <!-- ガード文言 -->
    <p>
      ※各会員の連携事例等について、当プラットフォーム及び運営事務局(内閣府)が管理・保証するものではありません。
    </p>

    <div class="search-flex">
      <!-- 検索条件入力 -->
      <div class="search-form-area">
        <form
          [formGroup]="h201SearchForm"
          (ngSubmit)="getResultCooperationDataList(true,true)"
        >
          条件を指定して「<i class="pi pi-search"></i>」をクリック
          <div class="p-d-flex p-jc-between">
            <!-- 検索テキスト -->
            <div class="search-text">
              <input
                type="text"
                pInputText
                placeholder="フリーワード検索"
                (focus)="text_focus.toggle($event)"
                (blur)="text_focus.toggle($event)"
                formControlName="freeword"
              />
              <p-overlayPanel #text_focus>
                <ng-template pTemplate>
                  <div class="overlay-search-text">さらに絞り込む</div>
                </ng-template>
              </p-overlayPanel>
            </div>
            <!-- 検索ボタン -->
            <button
              pButton
              type="submit"
              icon="pi pi-search"
              class="button1 search-button"
              (click)="getResultCooperationDataList(true,true)"
            ></button>
          </div>

          <!-- 検索フォーム -->
          <div class="search-form">
            <p-accordion
              [multiple]="true"
              expandIcon="pi pi-plus"
              collapseIcon="pi pi-minus"
            >
              <!-- 会員種別 -->
              <p-accordionTab
                header="会員種別"
                [(selected)]="accordion_class_id"
              >
                <div class="form">
                  <div *ngFor="let dicData of getDicList(1)">
                    <p-checkbox
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      [formControl]="h201SearchForm.controls.class_id"
                    ></p-checkbox>
                  </div>
                </div>
              </p-accordionTab>
              <!-- カテゴリ -->
              <p-accordionTab
                header="カテゴリ"
                [(selected)]="accordion_category"
              >
                <div *ngFor="let category of categoryList">
                  <!-- カテゴリ大項目 -->
                  <p-accordionTab
                    [(selected)]="accordion_category_detail[category.class_cd1]"
                  >
                    <ng-template pTemplate="header">
                      <p-checkbox
                        [label]="category.class_name1"
                        [value]="category.class_cd1"
                        (onChange)="checkLargeCategory($event, category.rec)"
                        [formControl]="h201SearchForm.controls.category"
                      >
                      </p-checkbox>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <!-- カテゴリ中項目 -->
                      <div class="form">
                        <div *ngFor="let list of category.rec">
                          <p-checkbox
                            [label]="list.class_name2"
                            [value]="list.value"
                            (onChange)="
                              checkMediumCategory(
                                $event,
                                category.class_cd1,
                                category.rec
                              )
                            "
                            [formControl]="h201SearchForm.controls.category"
                          ></p-checkbox>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </div>
              </p-accordionTab>
              <!-- 地域 -->
              <p-accordionTab
                header="地域"
                [(selected)]="accordion_prefectures"
              >
                <div *ngFor="let prefectures of prefecturesList">
                  <!-- 地域大項目 -->
                  <p-accordionTab
                    [(selected)]="
                      accordion_prefectures_detail[prefectures.code]
                    "
                  >
                    <ng-template pTemplate="header">
                      <p-checkbox
                        [label]="prefectures.name"
                        [value]="prefectures.code"
                        (onChange)="
                          checkLargePrefectures($event, prefectures.list)
                        "
                        [formControl]="h201SearchForm.controls.prefectures"
                      >
                      </p-checkbox>
                    </ng-template>
                    <ng-template pTemplate="content">
                      <!-- 地域中項目 -->
                      <div class="form">
                        <div *ngFor="let list of prefectures.list">
                          <p-checkbox
                            [label]="list.sp_name"
                            [value]="list.sp_name"
                            (onChange)="
                              checkMediumPrefectures(
                                $event,
                                prefectures.code,
                                prefectures.list
                              )
                            "
                            [formControl]="h201SearchForm.controls.prefectures"
                          ></p-checkbox>
                        </div>
                      </div>
                    </ng-template>
                  </p-accordionTab>
                </div>
              </p-accordionTab>
              <!-- 更新日 -->
              <p-accordionTab
                header="更新日"
                [(selected)]="accordion_update_date"
              >
                <div class="form">
                  <div class="p-col-fixed">
                    <p-calendar
                      [showIcon]="true"
                      [showButtonBar]="true"
                      [yearNavigator]="true"
                      [monthNavigator]="true"
                      placeholder="例）2021/07"
                      dateFormat="yy/mm/dd"
                      dataType="string"
                      appendTo="body"
                      yearRange="2000:2999"
                      formControlName="strdate"
                      translate
                    ></p-calendar>
                  </div>
                  <div class="verticalTilde">〜</div>
                  <div class="p-col-fixed">
                    <p-calendar
                      [showIcon]="true"
                      [showButtonBar]="true"
                      [yearNavigator]="true"
                      [monthNavigator]="true"
                      placeholder="例）2021/07"
                      dateFormat="yy/mm/dd"
                      dataType="string"
                      appendTo="body"
                      yearRange="2000:2999"
                      formControlName="enddate"
                      translate
                    ></p-calendar>
                  </div>
                </div>
              </p-accordionTab>
              <!-- 業種 -->
              <p-accordionTab
                header="業種"
                [(selected)]="accordion_industry_id"
              >
                <div class="form">
                  <div *ngFor="let dicData of getDicList(2)">
                    <p-checkbox
                      [label]="dicData.sp_name"
                      [value]="dicData.sp_code"
                      [formControl]="h201SearchForm.controls.industry_id"
                    ></p-checkbox>
                  </div>
                </div>
              </p-accordionTab>
              <!-- 目指すSDGsゴール -->
              <p-accordionTab
                header="目指すSDGsゴール"
                [(selected)]="accordion_sdgs_goal"
              >
                <div class="form form-sdgs-goal">
                  <div
                    class="checkbox-sdgs-goal p-d-flex p-as-center"
                    *ngFor="let dicData of getDicList(3)"
                  >
                    <p-checkbox
                      [value]="dicData.sp_code"
                      [formControl]="h201SearchForm.controls.sdgs_goal"
                    >
                    </p-checkbox>
                    <div class="image-margin"></div>
                    <img [src]="dicData.sp_ext" alt="image" />
                  </div>
                </div>
              </p-accordionTab>
            </p-accordion>
          </div>

          <!-- 検索ボタン -->
          <div class="p-d-flex p-jc-center">
            <button
              pButton
              type="button"
              label="検索"
              class="button1 new-button"
              (click)="getResultCooperationDataList(true,true)"
            ></button>
          </div>

          <!-- クリアボタン -->
          <p-button
            label="検索条件をクリアする"
            styleClass="p-button-link"
            (click)="h201SearchForm.reset()"
          ></p-button>
        </form>
      </div>
      <!-- 結果表示 -->
      <div class="result-area">
        <!-- ページアンカー -->
        <a id="jump-top"></a>

        <p-dataView
          #table
          [value]="resultCooperationDataList"
          [paginator]="true"
          [rows]="15"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first}~{last}件表示({totalRecords}件中)"
          [rowsPerPageOptions]="[15, 75, 150]"
          emptyMessage="データが存在しません"
          layout="grid"
          (onPage)="jumpTop()"
          [sortField]="sortField"
          [sortOrder]="sortOrder"
        >
          <!-- ヘッダー -->
          <ng-template pTemplate="header">
            <!-- 検索結果数 -->
            <div class="p-d-flex p-jc-between result-count-area">
              <div>
                <label class="count">
                  {{ resultCooperationDataList.length }}
                </label>
                件（総件数：{{ countCooperationData }}件）
              </div>
              <div class="p-as-center p-d-flex">
                <!-- ソート順の項目をここに記載する -->
                <div class="p-as-center">表示切替：</div>
                <p-dropdown
                  [options]="sortOptions"
                  [(ngModel)]="sortKey"
                  placeholder="選択してください"
                  (onChange)="onSortChange($event)"
                  styleClass="mb-2 md:mb-0"
                ></p-dropdown>
              </div>
            </div>
          </ng-template>
          <!-- グリッドアイテム -->
          <ng-template let-resultCooperationData pTemplate="gridItem">
            <div class="p-col-12 p-md-4">
              <a
                class="item-area item"
                [attr.href]="moveH301(resultCooperationData?.cooperation_id)"
                style="text-decoration:none; color: inherit;"
                target="_blank" >
                <!-- 事例イメージ -->
                <div class="image">
                  <img
                    [src]="resultCooperationData?.case_image1.file_path"
                    alt="image"
                  />
                </div>
                <!-- 事例タグ -->
                <div class="p-d-flex p-jc-left case-tag-area">
                  <div>
                    <p-tag
                      value="優良事例"
                      styleClass="p-button-text tag-type1"
                      *ngIf="resultCooperationData?.excellent_tag == '1'"
                    ></p-tag>
                  </div>
                  <div>
                    <p-tag
                      value="PF会員間連携"
                      styleClass="p-button-text tag-type2"
                      *ngIf="resultCooperationData?.case_tag.includes('1')"
                    ></p-tag>
                  </div>
                </div>
                <div class="title">{{ resultCooperationData.title }}</div>
                <br />
                <div class="collaboration_name">
                  {{ resultCooperationData?.public_representative }} ×
                  {{ resultCooperationData?.private_representatibe }}
                </div>
                <div class="category">
                  {{ resultCooperationData?.category }}
                </div>
                <div class="organization_name">
                  （登録団体：{{ resultCooperationData?.organization_name }}）
                </div>
              </a>
            </div>
          </ng-template>
        </p-dataView>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
